import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

const ListActionButtons = ({
  row,
  onView,
  onEdit,
  onDelete,
  showView = true,
  showEdit = true,
  showDelete = true,
  isHovered = false,
  viewTooltip = "View",
  editTooltip = "Edit",
  deleteTooltip = "Delete",
  viewColor = "primary",
  editColor = "secondary",
  deleteColor = "error",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        opacity: isHovered ? 1 : 0,
        transition: "opacity 0.2s",
        height: 30,
      }}
    >
      {showView && onView && (
        <Tooltip title={viewTooltip}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onView(row);
            }}
            color={viewColor}
          >
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      )}
      {showEdit && onEdit && (
        <Tooltip title={editTooltip}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onEdit(row);
            }}
            color={editColor}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      )}
      {showDelete && onDelete && (
        <Tooltip title={deleteTooltip}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDelete(row);
            }}
            color={deleteColor}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default ListActionButtons;
